export const BOTTOM_MAP_CARDS = {
	entityData: 'entityData',
	ownBooking: 'ownBooking',
	colleagueBooking: 'colleagueBooking',
	officeElement: 'officeElement',
	boothData: 'boothData'
};
